
export default {
  pt: {
    errors: {
        404: {
            title: 'Ops! Não encontramos essa página.',
            message: 'Esta página não está disponível. Explore nosso portfólio de imóveis ou continue sua busca.'
        },
        default: {
            title: 'Ops! Algo deu errado.',
            message: 'Por favor, tente novamente ou explore nosso portfólio de imóveis.'
        },
      },
    buttons: {
      goToHome: 'Ir para Home',
      goToProperties: 'Explorar imóveis',
    }
  },
};
